function IconPlus({ color, size = 10 }: { color: string, size?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 10 10" fill="none">
      <path d="M5 1V5M5 5V9M5 5H1M5 5H9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export default IconPlus;
